import { SyntheticEvent } from "react";
import { Task as ApiTask } from "@/api/mutation/useTaskCreateMutation";
import { BarTask } from "./bar-task";
import { AssignedUsers } from "@/api/query/useProjectQuery";
export enum ViewMode {
  Hour = "Hour",
  QuarterDay = "Quarter Day",
  HalfDay = "Half Day",
  Day = "Day",
  /** ISO-8601 week */
  Week = "Week",
  Month = "Month",
  QuarterYear = "QuarterYear",
  Year = "Year",
}
export type TaskType = "task" | "milestone" | "project";
export interface Task {
  assign: ApiTask["assignedUsers"];
  createdByUserId: string;
  id: string;
  type: TaskType;
  name: string;
  start: Date;
  end: Date;
  showProgress?:boolean,
  /**
   * From 0 to 100
   */
  progress: number;
  styles?: {
    backgroundColor?: string;
    backgroundSelectedColor?: string;
    progressColor?: string;
    progressSelectedColor?: string;
  };
  isDisabled?: boolean;
  project?: string;
  dependencies?: string[];
  hideChildren?: boolean;
  displayOrder?: number;
  baseLineTask?:Task[] | BarTask[]
}

export interface EventOption {
  /**
   * Time step value for date changes.
   */
  timeStep?: number;
  /**
   * Invokes on bar select on unselect.
   */
  onSelect?: (task: Task, isSelected: boolean) => void;
  /**
   * Invokes on bar double click.
   */
  onDoubleClick?: (task: Task) => void;
  /**
   * Invokes on bar click.
   */
  onClick?: (task: Task) => void;
  /**
   * Invokes on end and start time change. Chart undoes operation if method return false or error.
   */
  onDateChange?: (
    task: Task,
    children: Task[]
  ) => void | boolean | Promise<void> | Promise<boolean>;
  /**
   * Invokes on progress change. Chart undoes operation if method return false or error.
   */
  onProgressChange?: (
    task: Task,
    children: Task[]
  ) => void | boolean | Promise<void> | Promise<boolean>;
  /**
   * Invokes on delete selected task. Chart undoes operation if method return false or error.
   */
  onDelete?: (task: Task) => void | boolean | Promise<void> | Promise<boolean>;
  /**
   * Invokes on expander on task list
   */
  onExpanderClick?: (task: Task) => void;
}

export interface DisplayOption {
  viewMode?: ViewMode;
  viewDate?: Date;
  preStepsCount?: number;
  /**
   * Specifies the month name language. Able formats: ISO 639-2, Java Locale
   */
  locale?: string;
  rtl?: boolean;
}

export interface StylingOption {
  headerHeight?: number;
  columnWidth?: number;
  listCellWidth?: string;
  rowHeight?: number;
  ganttHeight?: number;
  barCornerRadius?: number;
  handleWidth?: number;
  fontFamily?: string;
  fontSize?: string;
  startEndIndicater?:boolean
  showContextManu?:boolean
  /**
   * How many of row width can be taken by task.
   * From 0 to 100
   */
  barFill?: number;
  barProgressColor?: string;
  barProgressSelectedColor?: string;
  barBackgroundColor?: string;
  barBackgroundSelectedColor?: string;
  projectProgressColor?: string;
  projectProgressSelectedColor?: string;
  projectBackgroundColor?: string;
  projectBackgroundSelectedColor?: string;
  milestoneBackgroundColor?: string;
  milestoneBackgroundSelectedColor?: string;
  arrowColor?: string;
  arrowIndent?: number;
  todayColor?: string;
  TooltipContent?: React.FC<{
    task: Task;
    fontSize: string;
    fontFamily: string;
  }>;
  UserTooltipContentComp?: React.FC<{
    task: Task;
    fontSize: string;
    fontFamily: string;
  }>;
  ContextMenuContent?:React.FC<{
    task: Task;
    fontSize: string;
    fontFamily: string;
    userId?: string;
    onEventCall: (data: { action: string; data: Task }) => void;
    onColorChange: (data: Task) => void;
    closeMenu: () => void;
  }>;
  TaskListHeader?: React.FC<{
    headerHeight: number;
    rowWidth: string;
    fontFamily: string;
    fontSize: string;
  }>;
  TaskListTable?: React.FC<{
    rowHeight: number;
    rowWidth: string;
    fontFamily: string;
    fontSize: string;
    locale: string;
    tasks: Task[];
    selectedTaskId: string;
    /**
     * Sets selected task by id
     */
    setSelectedTask: (taskId: string) => void;
    onExpanderClick: (task: Task) => void;
  }>;
}

export interface GanttProps extends EventOption, DisplayOption, StylingOption {
  canCreateDependency?:boolean
  onContextManuEvent:(data:{action:string,data:Task})=>void
  newTask:Task|undefined
  tasks: Task[];
  resourcesTask?: Task[];
  holidays?:Date[]
  nonWorkingDays?:number[]
  columns:columnsType[],
  projectStartDate:Date
  projectEndDate:Date
  apiResourceData?:any
  onScroll:(data: SyntheticEvent<HTMLDivElement>)=>void,
  onDepandanyClick:(data:any)=>void
  onColorChange:(data:Task)=>void
  setSelected?:(data:Task)=>void
  onDepandancyDraging:(
    from: { startTaskID: string; type: string },
    to: { endTaskID: string; type: string }
  )  => void;
  onDepandancyDragEnd: (
    from: { startTaskID: string; type: string },
    to: { endTaskID: string; type: string }
  )  => void;
  showWorkload?: boolean;
  resourceMember?:AssignedUsers[]
  setColumns?:(columns: columnsType[]) => void
  taskSorted?:(task:Task[]) => void
  setIsProject?:(data:boolean) => void
  setAPIData?:(data:any) => void
  inPercentage?:boolean
  workloadLoader?:boolean

}
type extedTaskType = Task & {
  assign:any[]
  status:string
  flag:string
  duration:number
}
export interface columnsType {
  field: string;
  name: string;
  width?: number;
  render?: (task: extedTaskType) => React.ReactNode;
  headerRender?: () => React.ReactNode;
  sortable?: boolean;
  optional?: boolean;
  hidden?: boolean;
  nonDragable?:boolean
}